<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Reporte de ofertas</h2>
    <MainPromotionOffersReport />
  </div>
</template>

<script>
import { onBeforeMount, onMounted } from "vue";
import { useRoute } from "vue-router";
import MainPromotionOffersReport from "@/components/Reports/Sales/PromotionOffers/MainPromotionOffersReport.vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";

export default {
  name: "PromotionOffersReport",
  components: {
    MainPromotionOffersReport,
  },
  setup() {
    const route = useRoute();

    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
    });
  },
};
</script>